import {
    FREE_AMOUNT_ON_ORDER,
    FREE_AMOUNT_ON_PRODUCT,
    FREE_PRODUCT,
    PERCENT_ON_ORDER,
    PERCENT_ON_PRODUCT,
} from "@constants";
import { t } from "i18next";
import { snapshot } from "valtio";

import { kioskStore } from "../store";

export function handleCodePromoSymbole(discountType: number): string {
    const { devise } = snapshot(kioskStore);
    switch (discountType) {
        case PERCENT_ON_ORDER:
        case PERCENT_ON_PRODUCT:
            return "%";
        case FREE_AMOUNT_ON_ORDER:
        case FREE_AMOUNT_ON_PRODUCT:
            return devise.deviseSymbole || "€";
        case FREE_PRODUCT:
            return t("Free");
        default:
            return "";
    }
}

/**
 * Reward expiration dates come as ISO timestamps (2026-08-08T15:41:00).
 * Only the day is relevant on the reward card, so keep it short (08/08/2026)
 * and fall back to the raw value when the date cannot be parsed.
 */
export function formatRewardExpirationDate(date: string): string {
    const trimmedDate = (date ?? "").trim();

    if (trimmedDate === "") {
        return "";
    }

    const parsedDate = new Date(trimmedDate);

    if (isNaN(parsedDate.getTime())) {
        return trimmedDate;
    }

    const day = `${parsedDate.getDate()}`.padStart(2, "0");
    const month = `${parsedDate.getMonth() + 1}`.padStart(2, "0");

    return `${day}/${month}/${parsedDate.getFullYear()}`;
}
